import React, { Fragment, useState } from 'react';
import { Validate_form } from './components/Validate_form';
import { Maintenance } from './components/Maintenance';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

export function App() {
    return (
       <Fragment>
        <Validate_form/>
       </Fragment>
//     <div>
//     <BrowserRouter>
//     <Routes>
//      <Route exact path="logistics/" element={<Validate_form />}>
//      </Route>
//      <Route exact path="logistics/maintenance" element={<Maintenance/>}>          
//      </Route>
//     </Routes>
//    </BrowserRouter>
//    </div>
    );
    
}


export default Maintenance;